// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.f45fdce04',
  revision: 'f45fdce04',
  branch: 'develop',
  date: 'Fri, 25 Sep 2026 14:40:04 GMT'
};